import { gql } from '@apollo/client';

export const DELETE_CREATIVE_TAGS = gql`
    mutation DeleteCreativeTags($deleteCreativeTagsNode: DeleteCreativeTagsNode!) {
        deleteCreativeTags(deleteCreativeTagsNode: $deleteCreativeTagsNode) {
            ok
            message
        }
    }
`;
